enum TemplateType {
    Text,
    Poll,
    OptIn,
}

export default TemplateType;
